import { Button, type ButtonProps } from '@mantine/core'
import { useCallback } from 'react'

import { useTranslation } from '@flecto/translations'
import { useMediaQuery, useNotifications } from '@flecto/ui'

import { useStoreAnalytics } from '../../hooks/useStoreAnalytics'
import { useStoreBasket } from '../../hooks/useStoreBasket'
import { type ItemWithAvailability } from '../../types/ItemWithAvailability'
import styles from './styles.module.css'

export type ButtonItemAddToCartProps = ButtonProps & {
  item?: ItemWithAvailability
  quantity?: number
}

export function ButtonItemAddToCart({
  item,
  quantity = 1,
  ...props
}: ButtonItemAddToCartProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })
  const { isDesktop } = useMediaQuery()
  const { showNotification } = useNotifications()
  const { addQuantity, items } = useStoreBasket()
  const { track } = useStoreAnalytics()

  const handleAddToCart = useCallback(() => {
    if (items.length === 0) {
      track('NEW__BASKET', {
        item_id: item?.id ?? '',
        item_quantity: quantity,
      })
    } else {
      track('UPDATE__BASKET', {
        item_ids: items.map((i) => i.item.id),
        type: 'add',
      })
    }

    if (item) {
      addQuantity(item, quantity)

      if (isDesktop) {
        showNotification({
          type: 'success',
          message: t('button_item_add_to_cart.notification_added', {
            count: quantity,
            product: item.title,
          }),
        })
      }
    }
  }, [item])

  if (!item) {
    return
  }

  return (
    <Button className={styles.button} {...props} onClick={handleAddToCart}>
      {t('button_item_add_to_cart.label_button')}
    </Button>
  )
}
